import { render, staticRenderFns } from "./SmMaterialInputIcon.vue?vue&type=template&id=c022e488&"
import script from "./SmMaterialInputIcon.vue?vue&type=script&lang=ts&"
export * from "./SmMaterialInputIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports